
// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Button,
//   Tooltip,
//   TextField,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   TablePagination,
//   Paper,
//   Typography,
//   Breadcrumbs,
//   Link,
//   TableSortLabel,
//   IconButton,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Pagination,
//   Stack,
//   CircularProgress,
//   Autocomplete
// } from '@mui/material';
// import { useNavigate } from 'react-router-dom';
// import moment from 'moment';
// import { usePermissions } from '../../../GlobalFunction/userPermissions';
// import axiosInstance from '../../../lib/axios';
// import AddIcon from '@mui/icons-material/Add';
// import PropertyFilter from '../../PropertyFilter';
// import SaveAltIcon from '@mui/icons-material/SaveAlt';
// import * as XLSX from 'xlsx';
// import { visuallyHidden } from '@mui/utils';
// import NorthIcon from '@mui/icons-material/North';
// import SouthIcon from '@mui/icons-material/South';
// import { useSelector, useDispatch } from 'react-redux';
// import ReplayIcon from '@mui/icons-material/Replay';
// import {
//   selectProperties,
//   selectGlobalProperty,
//   selectLocalProperty,
//   setLocalProperty,
//   fetchProperties
// } from '../../../redux/propertySlice';

// const TableFollowUp = () => {
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(15);
//   const [searchTerms, setSearchTerms] = useState({});
//   const [rows, setRows] = useState([]);
//   const [totalRecords, setTotalRecords] = useState(0);
//   const [totalPages, setTotalPages] = useState(0);
//   const [loading, setLoading] = useState(false);
//   const [isExporting, setIsExporting] = useState(false);
//   const permissions = usePermissions("Follow-Ups");
//   const { AddRec = "0" } = permissions || {};
//   const navigate = useNavigate();
//   const [propertyOptions, setPropertyOptions] = useState([]);
//   const [SelectedProperty, setSelectedProperty] = useState(null);
//   const UserId = sessionStorage?.getItem('UserId');
//   const [order, setOrder] = useState('');
//   const [orderBy, setOrderBy] = useState('');
//   const [columnResizing, setColumnResizing] = useState(null);
//   const [globalSearchTerm, setGlobalSearchTerm] = useState('');
//     const [followByOptions, setFollowByOptions] = useState([]); 
//   const [selectedFollowBy, setSelectedFollowBy] = useState(null); 
//   const [columnWidths, setColumnWidths] = useState({
//     FlwUpBy: 90,
//     EnqNo: 90,
//     EnqDt: 85,
//     FlwDt: 100,
//     EnqTypeNm: 70,
//     VisitSt: 40,
//     Remark: 100,
//     NextFlwDt: 100,
//     EnqBy: 80,
//     EnqFor: 95,
//     MobileNo: 90,
//     Tenure: 50,
//     Days: 50,
//     SourceBy: 95,
//     SourceName: 120,
//     VisitEmpNm: 100,
//     VisitRemark: 200,
//     OtherRmk: 200
//   });
//   const dispatch = useDispatch();
//   const properties = useSelector(selectProperties);
//   const globalProperty = useSelector(selectGlobalProperty);
//   const localProperty = useSelector(state => selectLocalProperty(state, 'followUp'));
//   const selectedProperty = localProperty || globalProperty;

//   const columns = [
//     { id: 'FlwUpBy', label: 'Follow By', width: 100 },
//     { id: 'EnqNo', label: 'EnquiryNo.', width: 80 },
//     { id: 'EnqDt', label: 'EnqDate', width: 100 },
//     { id: 'LastFlwDt', label: 'LastFollowUp', width: 100 },
//     { id: 'EnqTypeNm', label: 'EnqType', width: 70 },
//     { id: 'VisitSt', label: 'Visit', width: 50 },
//     { id: 'Remark', label: 'Remark', width: 150 },
//     { id: 'NextFlwDt', label: 'NextFollowUp', width: 100 },
//     { id: 'EnqBy', label: 'EnqBy', width: 120 },
//     { id: 'EnqFor', label: 'EnqFor', width: 120 },
//     { id: 'MobileNo', label: 'Mobile No.', width: 120 },
//     { id: 'Tenure', label: 'Tenure', width: 60 },
//     { id: 'Days', label: 'Days', width: 90 },
//     { id: 'SourceBy', label: 'SourceBy', width: 120 },
//     { id: 'SourceName', label: 'SourceName', width: 150 },
//     { id: 'VisitEmpNm', label: 'Visit With', width: 120 },
//     { id: 'VisitRemark', label: 'VisitRemark', width: 200 },
//     { id: 'OtherRmk', label: 'Remark', width: 200 }
//   ];

//   useEffect(() => {
//     if (properties.length === 0) {
//       dispatch(fetchProperties());
//     }
//   }, [dispatch, properties.length]);

//  const fetchFollowBy = async () => {
//   try {
//     const response = await axiosInstance.post(
//       `UserMst/getAllUserMstDashBoard`,
//       {
//         "SearchText": "" 
//       }
//     );
//     if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
//        const options = response.data.Data.map(user => ({
//         ...user,
//         Name: user.UserName 
//       }));
//       setFollowByOptions(options);
//     }
//   } catch (error) {
//     console.error('Error fetching follow by options:', error);
//   }
// };


//     useEffect(() => {
//     fetchFollowBy();
//   }, []);
//    const handleFollowByChange = (event, newValue) => {
//     setSelectedFollowBy(newValue);
//   };
//   const filteredRows = React.useMemo(() => {
//     return rows.filter(row => {
//       return Object.entries(searchTerms).every(([columnId, term]) => {
//         if (!term) return true;
//         const value = row[columnId];
//         if (typeof value === 'string') {
//           return value.toLowerCase().includes(term.toLowerCase());
//         } else if (typeof value === 'number') {
//           return value.toString().includes(term);
//         }
//         return true;
//       });
//     });
//   }, [searchTerms, rows]);
//   const sortedRows = React.useMemo(() => {
//     return [...filteredRows].sort((a, b) => {
//       if (a[orderBy] < b[orderBy]) {
//         return order === 'asc' ? -1 : 1;
//       }
//       if (a[orderBy] > b[orderBy]) {
//         return order === 'asc' ? 1 : -1;
//       }
//       return 0;
//     });
//   }, [filteredRows, order, orderBy]);
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       if (selectedProperty) {
//         fetchFollowUpData();
//       }
//     }, 1000);

//     return () => clearTimeout(timer);
//   }, [globalSearchTerm, selectedProperty, page, rowsPerPage]);
//   // useEffect(() => {
//   //   if (selectedProperty) {
//   //     fetchFollowUpData();
//   //   }
//   // }, [selectedProperty, page, rowsPerPage]);

//   useEffect(() => {
//     fetchPropertyOptions();
//   }, []);

//   const handlePropertyChange = (event) => {
//     const selectedId = event.target.value;
//     dispatch(setLocalProperty({
//       componentId: 'followUp',
//       propertyId: selectedId
//     }));

//     if (selectedId) {
//       setSearchTerms(prev => ({ ...prev, PropId: selectedId }));
//       setPage(0);
//     } else {
//       const { PropId, ...rest } = searchTerms;
//       setSearchTerms(rest);
//     }
//   };

//   const fetchFollowUpData = async () => {
//     if (!selectedProperty) return;

//     setLoading(true);
//     try {
//       const currentPage = page + 1;


//       const response = await axiosInstance.post(
//              `TrnFlwup/GetTrnFlwupDashBoard?currentPage=1&limit=15`,
//         // `TrnFlwup/GetTrnFlwupDashBoard?currentPage=${currentPage}&limit=${rowsPerPage}`,
//         {
//           "PageNumber": globalSearchTerm ? 1 : currentPage,
//           "PageSize": globalSearchTerm ? 1 : rowsPerPage,
//           "SearchText": globalSearchTerm,
//           "PropId": selectedProperty.Id || selectedProperty,
//           "Flag": "",
//           "FlwUserId":selectedFollowBy.UserId
//         }
//       );

//       if (response.data.Status === 0) {
//         const formattedData = response?.data?.Data?.map(item => ({
//           ...item,
//           EnqDt: item.EnqDt ? moment(item.EnqDt).format('DD-MM-YYYY') : '',
//           NextFlwDt: item.NextFlwDt ? moment(item.NextFlwDt).format('DD-MM-YYYY') : '',
//           FlwDt: item.FlwDt ? moment(item.FlwDt).format('DD-MM-YYYY') : '',
//           LastFlwDt: item.LastFlwDt ? moment(item.LastFlwDt).format('DD-MM-YYYY') : '',
//           OtherRmk: item.OtherRmk,
//           VisitSt: item.VisitSt === 'Y' ? 'Yes' : 'No'
//         }));

//         setRows(formattedData);

//         if (response.data.PageData) {
//           setTotalRecords(response.data.PageData.TotalRecords);
//           setTotalPages(response.data.PageData.TotalPages);
//         } else {
//           setTotalRecords(response.data.TotalRowCount || 0);
//           setTotalPages(Math.ceil((response.data.TotalRowCount || 0) / rowsPerPage));
//         }
//       } else {
//         setRows([]);
//         setTotalRecords(0);
//         setTotalPages(0);
//         console.error('Error fetching followup data:', response.data.Message);
//       }
//     } catch (error) {
//       setRows([]);
//       setTotalRecords(0);
//       setTotalPages(0);
//       console.error('Error fetching followup data:', error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handlePermittedClick = () => {
//     if (AddRec === "1") {
//       navigate('/enquiry');
//     }
//   };

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(+event.target.value);
//     setPage(0);
//   };

//   const handleSearchChange = (columnId, value) => {
//     console.log('valye', value)
//     setSearchTerms(prev => ({ ...prev, [columnId]: value }));
//     setPage(0);
//   };

//   const handleRequestSort = (property) => {
//     if (orderBy !== property) {
//       setOrder('asc');
//       setOrderBy(property);
//       return;
//     }

//     const isAsc = order === 'asc';
//     setOrder(isAsc ? 'desc' : 'asc');

//     fetchFollowUpData();
//   };

//   const handleRowDoubleClick = (row) => {
//     navigate('/FollowupForm', { state: { EnqId: row.EnqId, mode: 'view' } });
//   };

//   const handleExportToExcel = async () => {
//     setIsExporting(true);
//     try {
//       const response = await axiosInstance.post(
//         `TrnFlwup/GetTrnFlwupDashBoard?currentPage=1&limit=${totalRecords}`,
//         {
//           "PageNumber": 1,
//           "PageSize": totalRecords,
//           "SearchText": "",
//           "PropId": selectedProperty.Id || selectedProperty,
//           "Flag": ""
//         }
//       );

//       if (response.data.Status === 0) {
//         const exportData = response.data.Data.map((row) => {
//           let rowData = {};
//           columns.forEach((col) => {
//             let value = row[col.id];
//             if (col.id === 'NextFlwDt' || col.id === 'FlwDt' || col.id === 'EnqDt') {
//               value = value ? moment(value).format('DD-MM-YYYY') : '';
//             }
//             if (col.id === 'VisitSt') {
//               value = value === 'Y' ? 'Yes' : 'No';
//             }
//             rowData[col.label] = value || "";
//           });
//           return rowData;
//         });

//         const worksheet = XLSX.utils.json_to_sheet(exportData);
//         const workbook = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(workbook, worksheet, "FollowUpData");
//         XLSX.writeFile(workbook, `FollowUp_${new Date().toISOString().split('T')[0]}.xlsx`);
//       }
//     } catch (error) {
//       console.error("Export failed:", error);
//     } finally {
//       setIsExporting(false);
//     }
//   };

//   const fetchPropertyOptions = async () => {
//     try {
//       const response = await axiosInstance.post(`PropertyMst/getPropertyMstdrp`, {
//         UserId,
//         Flag: ""
//       });
//       if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
//         setPropertyOptions(response.data.Data);
//       }
//     } catch (error) {
//       console.error("Error fetching properties", error);
//     }
//   };

//   const handleRetrieve = () => {
//     // setPage(0); 
//     // fetchFollowUpData(); 
//   };

//   const getCellStyle = (columnId, value) => {
//     if (columnId === 'EnqTypeNm') {
//       switch (value) {
//         case 'Hot': return { backgroundColor: '#FF0000', color: 'white', borderRadius: '4px' };
//         case 'Warm': return { backgroundColor: '#FFBF00', color: 'white', borderRadius: '4px' };
//         case 'Booked': return { backgroundColor: '#01bc5f', color: 'white', borderRadius: '4px' };
//         case 'Refund': return { backgroundColor: '#4d7499', color: 'white', borderRadius: '4px' };
//         case 'Not interested': return { backgroundColor: '#FF6347', color: 'white', borderRadius: '4px' };
//         case 'Incorrect Lead': return { backgroundColor: '#922b21', color: 'white', borderRadius: '4px' };
//         case 'Cold': return { backgroundColor: '#0000FF', color: 'white', borderRadius: '4px' };
//         case 'Low Budget': return { backgroundColor: '#148f77', color: 'white', borderRadius: '4px' };
//         case 'Others': return { backgroundColor: '#FFA500', color: 'white', borderRadius: '4px' };
//         default: return {};
//       }
//     }
//     if (columnId === 'VisitSt') {
//       return value === 'Yes'
//         ? { backgroundColor: '#4CAF50', color: 'white', borderRadius: '4px', textAlign: 'center' }
//         : { backgroundColor: '#F44336', color: 'white', borderRadius: '4px', textAlign: 'center' };
//     }
//     return {};
//   };

//   const [resizeStartX, setResizeStartX] = useState(0);
//   const [resizeStartWidth, setResizeStartWidth] = useState(0);

//   const startResizing = (columnId, e) => {
//     setColumnResizing(columnId);
//     setResizeStartX(e.clientX);
//     setResizeStartWidth(columnWidths[columnId]);
//   };

//   const handleMouseMove = (e) => {
//     if (columnResizing) {
//       const deltaX = e.clientX - resizeStartX;
//       const newWidth = Math.max(50, resizeStartWidth + deltaX);

//       setColumnWidths(prev => ({
//         ...prev,
//         [columnResizing]: newWidth
//       }));
//     }
//   };

//   const stopResizing = () => {
//     setColumnResizing(null);
//     setResizeStartX(0);
//     setResizeStartWidth(0);
//   };
// const FollowByFilter = (
//   <Autocomplete
//     id="follow-by-filter"
//     options={followByOptions}
//     getOptionLabel={(option) => option.UserName || ""} // Use UserName instead of Name
//     value={selectedFollowBy}
//     onChange={handleFollowByChange}
//     size="small"
//     sx={{ minWidth: 200 }}
//     renderInput={(params) => (
//       <TextField 
//         {...params} 
//         label="Follow By" 
//         variant="outlined" 
//       />
//     )}
//     isOptionEqualToValue={(option, value) => option.UserId === value?.UserId}
//   />
// );
//   const PropertyFilterJSX = (
//     <FormControl fullWidth size="small" sx={{ minWidth: 200 }}>
//       <InputLabel id="property-select-label">Filter by Property</InputLabel>
//       <Select
//         labelId="property-select-label"
//         id="property-select"
//         value={selectedProperty?.Id || selectedProperty || ''}
//         onChange={handlePropertyChange}
//         label="Filter by Property"
//       >
//         {propertyOptions.map((property) => (
//           <MenuItem key={property.Id} value={property.Id}>
//             {property.Name}
//           </MenuItem>
//         ))}
//       </Select>
//     </FormControl>
//   );

//   return (
//     <>
//       <Box sx={{ maxWidth: '95vw', margin: ' auto', padding: '10px', background: 'rgb(249, 249, 249)' }}>
//         <Box
//           sx={{
//             backgroundColor: "#ffffff",
//             padding: { xs: "8px 16px", sm: "12px 16px" },
//             display: "flex",
//             justifyContent: "space-between",
//             alignItems: "center",
//             boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
//             borderRadius: "12px",
//             margin: "10px auto",
//             maxWidth: "95%",
//             flexDirection: { xs: "column", sm: "column", md: "row" }
//           }}
//         >
//           <Breadcrumbs
//             aria-label="breadcrumb"
//             separator="›"
//             sx={{
//               fontSize: { xs: "14px", sm: "16px" },
//               display: "flex",
//               flexDirection: { xs: "column", sm: "column", md: "row" }
//             }}
//           >
//             <Link
//               color="#635bff"
//               onClick={() => navigate('/dashboard')}
//               underline="hover"
//               sx={{ cursor: "pointer", fontWeight: "500" }}
//             >
//               Home
//             </Link>
//             <Link
//               color="#635bff"
//               onClick={() => navigate('/enquiry/pre-registration')}
//               underline="hover"
//               sx={{ cursor: "pointer", fontWeight: "500" }}
//             >
//               Booking(Pre-Registration)
//             </Link>
//             <Typography color="text.primary" sx={{ fontWeight: "500" }}>
//               Follow Up
//             </Typography>
//           </Breadcrumbs>

//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "end",
//               gap: "16px",
//               minWidth: "300px",
//               flexDirection: { xs: "column", sm: "column", md: "row" },
//               marginTop: { xs: "16px", sm: "16px", md: "0px" }
//             }}
//           >
//               {PropertyFilterJSX}
//               {FollowByFilter}

//             <Button
//               variant="contained"
//               onClick={handleRetrieve}
//               disabled={loading}
//               sx={{
//                 backgroundColor: "#635bff",
//                 color: "#ffffff",
//                 borderRadius: '20px',
//                 minWidth: "100px",
//                 '&:hover': {
//                   backgroundColor: '#524ccc'
//                 }
//               }}
//             >

//               <ReplayIcon sx={{ fontSize: '18px', mr: 1 }} /> Retrieve
//             </Button>
//             <Tooltip title={AddRec !== "1" ? "You have no permission to add record" : ""}>
//               <span>
//                 <Button
//                   variant="contained"
//                   onClick={handlePermittedClick}
//                   size="small"
//                   disabled={AddRec !== "1"}
//                   sx={{
//                     backgroundColor: "#635bff",
//                     color: "#ffffff",
//                     padding: "6px 14px",
//                     borderRadius: '20px',
//                     whiteSpace: 'nowrap',
//                     '&:hover': {
//                       backgroundColor: '#524ccc'
//                     }
//                   }}
//                 >
//                   <AddIcon sx={{ fontSize: '18px', mr: 1 }} />
//                   NEW ENQ
//                 </Button>
//               </span>
//             </Tooltip>

//             <Button
//               variant="contained"
//               onClick={handleExportToExcel}
//               sx={{
//                 backgroundColor: "#635bff",
//                 color: "#ffffff",
//                 minWidth: "100px",
//                 borderRadius: '20px',
//                 '&:hover': {
//                   backgroundColor: '#524ccc'
//                 }
//               }}
//               disabled={isExporting}
//             >
//               <SaveAltIcon sx={{ fontSize: '18px', mr: 1 }} />
//               {isExporting ? "Exporting..." : "EXPORT"}
//             </Button>
//           </Box>
//         </Box>

//         <Paper sx={{ width: '94%', overflow: 'hidden', boxShadow: 3, margin: 'auto' }}>
//           <Box sx={{ position: 'relative' }}>

//             <TableContainer
//               sx={{
//                 maxHeight: 'calc(100vh - 250px)',
//                 '&::-webkit-scrollbar': {
//                   height: '5px',
//                   width: '5px'
//                 },
//                 '&::-webkit-scrollbar-thumb': {
//                   backgroundColor: 'gray',
//                   borderRadius: '4px'
//                 }
//               }}
//               onMouseMove={handleMouseMove}
//               onMouseUp={stopResizing}
//               onMouseLeave={stopResizing}
//             >
//               <Table stickyHeader aria-label="sticky table" size="small" sx={{ padding: '10px' }}>
//                 <TableHead>
//                   <TableRow>
//                     {columns.map((column) => (
//                       <TableCell
//                         key={column.id}
//                         sx={{
//                           width: columnWidths[column.id] || column.width,
//                           minWidth: columnWidths[column.id] || column.width,
//                           backgroundColor: '#dddbff',
//                           fontWeight: 'bold',
//                           padding: '4px 3px',
//                           borderRight: '1px solid #e0e0e0',
//                           position: 'sticky',
//                           '&:last-child': {
//                             borderRight: 'none'
//                           }
//                         }}
//                         sortDirection={orderBy === column.id ? order : false}
//                       >
//                         <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                           <TableSortLabel
//                             active={orderBy === column.id}
//                             direction={orderBy === column.id ? order : 'asc'}
//                             onClick={() => handleRequestSort(column.id)}
//                             sx={{ flexGrow: 1 }}
//                             IconComponent={() => (
//                               <Box component="span" sx={{
//                                 opacity: orderBy === column.id ? 1 : 0.3,
//                                 transition: 'opacity 0.2s',
//                                 '&:hover': { opacity: 1 }
//                               }}>
//                                 {orderBy === column.id ?
//                                   (order === 'asc' ? <NorthIcon sx={{ fontSize: 15, marginTop: 1 }} /> : <SouthIcon sx={{ fontSize: 15, marginTop: 1 }} />) :
//                                   <SouthIcon sx={{ fontSize: 15, marginTop: 1, opacity: 0.3 }} />
//                                 }
//                               </Box>
//                             )}
//                           >
//                             {column.label}
//                             {orderBy === column.id ? (
//                               <Box component="span" sx={visuallyHidden}>
//                                 {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
//                               </Box>
//                             ) : null}
//                           </TableSortLabel>
//                         </Box>
//                         <Box>
//                           <TextField
//                             size="small"
//                             variant="outlined"
//                             placeholder={`Search`}
//                             onChange={(e) => handleSearchChange(column.id, e.target.value)}
//                             sx={{
//                               width: '100%',
//                               '& .MuiOutlinedInput-root': {
//                                 borderRadius: '8px',
//                                 backgroundColor: '#f9f9f9',
//                                 fontSize: '0.75rem',
//                                 height: '24px',
//                                 padding: '0 8px'
//                               },
//                               '& .MuiOutlinedInput-input': {
//                                 padding: '6px 4px'
//                               }
//                             }}
//                           />
//                         </Box>
//                         <Box
//                           sx={{
//                             position: 'absolute',
//                             right: 0,
//                             top: 0,
//                             height: '100%',
//                             width: '4px',
//                             cursor: 'col-resize',
//                             backgroundColor: columnResizing === column.id ? '#635bff' : 'transparent',
//                             '&:hover': {
//                               backgroundColor: '#635bff'
//                             }
//                           }}
//                           onMouseDown={(e) => startResizing(column.id, e)}
//                         />
//                       </TableCell>
//                     ))}
//                   </TableRow>
//                 </TableHead>
//                 {loading && (
//                   <Box
//                     sx={{
//                       display: 'flex',
//                       justifyContent: 'center',
//                       alignItems: 'center',
//                       textAlign: 'center',
//                       p: 2,
//                     }}
//                   >
//                     <CircularProgress />
//                     Loading...
//                   </Box>
//                 )}
//                 <TableBody>
//                   {!loading && filteredRows.length > 0 ? (
//                     filteredRows.map((row, index) => (
//                       <TableRow
//                         hover
//                         key={row.EnqId || index}
//                         onDoubleClick={() => handleRowDoubleClick(row)}
//                         sx={{
//                           '&:hover': { cursor: 'pointer' },
//                           '&:nth-of-type(even)': {
//                             backgroundColor: '#f9f9f9'
//                           }
//                         }}
//                       >
//                         {columns.map((column) => {
//                           const value = row[column.id];
//                           return (
//                             <TableCell
//                               key={column.id}
//                               sx={{
//                                 width: columnWidths[column.id] || column.width,
//                                 minWidth: columnWidths[column.id] || column.width,
//                                 maxWidth: columnWidths[column.id] || column.width,
//                                 padding: '1px 6px',
//                                 overflow: 'hidden',
//                                 textOverflow: 'ellipsis',
//                                 whiteSpace: 'nowrap',
//                                 borderRight: '1px solid #e0e0e0',
//                                 '&:last-child': {
//                                   borderRight: 'none'
//                                 },
//                                 ...getCellStyle(column.id, value)
//                               }}
//                             >
//                               <Tooltip
//                                 title={value}
//                                 arrow
//                                 placement="top"
//                                 componentsProps={{
//                                   tooltip: {
//                                     sx: {
//                                       fontSize: '14px',
//                                       maxWidth: '500px',
//                                     }
//                                   }
//                                 }}
//                               >
//                                 <span>{value}</span>
//                               </Tooltip>
//                             </TableCell>
//                           );
//                         })}
//                       </TableRow>
//                     ))
//                   ) : !loading ? (
//                     <TableRow>
//                       <TableCell colSpan={columns.length} sx={{ textAlign: 'center', py: 4 }}>
//                         <Typography variant="body2" color="textSecondary">
//                           No records found
//                         </Typography>
//                       </TableCell>
//                     </TableRow>
//                   ) : null}
//                 </TableBody>
//               </Table>
//             </TableContainer>

//           </Box>
//           <TablePagination
//             rowsPerPageOptions={[15, 50, 100, 500, 1000, 5000, 10000]}
//             component="div"
//             count={totalRecords}
//             rowsPerPage={rowsPerPage}
//             page={page}
//             onPageChange={handleChangePage}
//             onRowsPerPageChange={handleChangeRowsPerPage}
//             sx={{
//               borderTop: '1px solid #e0e0e0',
//               background: '#dddbff',
//               '& .MuiTablePagination-toolbar': {
//                 minHeight: '52px',
//                 padding: '0 16px'
//               },
//               '& .MuiTablePagination-spacer': {
//                 flex: 1,
//               },
//             }}
//             ActionsComponent={() => (
//               <Stack
//                 direction="row"
//                 alignItems="center"
//                 sx={{
//                   justifyContent: "center",
//                   marginLeft: "16px",
//                 }}
//               >
//                 <Pagination
//                   count={totalPages}
//                   page={page + 1}
//                   onChange={(event, newPage) => setPage(newPage - 1)}
//                   showFirstButton
//                   showLastButton
//                   sx={{
//                     "& .MuiPaginationItem-root.Mui-selected": {
//                       backgroundColor: "#635bff",
//                       color: "#ffffff",
//                     },
//                   }}
//                 />
//               </Stack>
//             )}
//             labelDisplayedRows={({ from, to, count }) =>
//               `${from}-${to} of ${count !== -1 ? count : `more than ${to}`}`
//             }
//             labelRowsPerPage="Rows per page:"
//           />
//         </Paper>
//       </Box>
//     </>
//   );
// };

// export default TableFollowUp;



// 2nd approch data

import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Tooltip,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  Typography,
  Breadcrumbs,
  Link,
  TableSortLabel,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Pagination,
  Stack,
  CircularProgress,
  Autocomplete,
  FormControlLabel,
  RadioGroup,
  Radio
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { usePermissions } from '../../../GlobalFunction/userPermissions';
import axiosInstance from '../../../lib/axios';
import AddIcon from '@mui/icons-material/Add';
import PropertyFilter from '../../PropertyFilter';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import * as XLSX from 'xlsx';
import { visuallyHidden } from '@mui/utils';
import NorthIcon from '@mui/icons-material/North';
import SouthIcon from '@mui/icons-material/South';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useSelector, useDispatch } from 'react-redux';
import ReplayIcon from '@mui/icons-material/Replay';
import {
  selectProperties,
  selectGlobalProperty,
  selectLocalProperty,
  setLocalProperty,
  fetchProperties
} from '../../../redux/propertySlice';
import TodayFollowUpPopup from './TodayFollowUpPopup';
import TodayEnqListPopup from '../EnquiryMaster/TodayEnqListPopup';
import BulkUpdateEnquiryDialog from './BulkUpdateEnquiryDialog';

const TableFollowUp = () => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [searchTerms, setSearchTerms] = useState({});
  const [allRows, setAllRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isExporting, setIsExporting] = useState(false);
  const permissions = usePermissions("Follow-Ups");
  const { AddRec = "0" } = permissions || {};
  const navigate = useNavigate();
  const [propertyOptions, setPropertyOptions] = useState([]);
  const [SelectedProperty, setSelectedProperty] = useState(null);
  const UserId = sessionStorage?.getItem('UserId');
  const [order, setOrder] = useState('');
  const [orderBy, setOrderBy] = useState('');
  const [columnResizing, setColumnResizing] = useState(null);
  const [globalSearchTerm, setGlobalSearchTerm] = useState('');
  const [followByOptions, setFollowByOptions] = useState([]);
  const [selectedFollowBy, setSelectedFollowBy] = useState('');
  const [dataFetched, setDataFetched] = useState(false);
  const [propId, setPropId] = useState('')
  const [statusFilter, setStatusFilter] = useState("Open");
  const [selectedRows, setSelectedRows] = useState(new Set())
  const [openTodayPopup, setOpenTodayPopup] = useState(false);
    const [openTodayEPopup, setOpenTodayEPopup] = useState(false);
  const [columnWidths, setColumnWidths] = useState({
    FlwUpBy: 80,
    EnqNo: 85,
    EnqDt: 85,
    FlwDt: 100,
    Property:90,
    EnqTypeNm: 60,
    VisitSt: 40,
    Remark: 100,
    NextFlwDt: 100,
    EnqBy: 80,
    EnqFor: 80,
    MobileNo: 90,
    Tenure: 50,
    Days: 50,
    SourceBy: 80,
    SourceName: 90,
    VisitEmpNm: 80,
    VisitRemark: 150,
    OtherRmk: 150
  });
  const dispatch = useDispatch();
  const properties = useSelector(selectProperties);
  const globalProperty = useSelector(selectGlobalProperty);
  const localProperty = useSelector(state => selectLocalProperty(state, 'followUp'));
  const selectedProperty = localProperty || globalProperty;
  const [filterStatus, setFilterStatus] = useState("All");
const [searchText, setSearchText] = useState('');
  const userName = localStorage.getItem("userName")?.trim();
    const [openBulkUpdate, setOpenBulkUpdate] = useState(false)
  useEffect(() => {
    if (followByOptions.length > 0) {
      const matchedOption = userName
        ? followByOptions.find(option =>
          option.UserName?.trim() === userName
        )
        : null;
      setSelectedFollowBy(matchedOption || followByOptions[0]);
    }
  }, [followByOptions, userName]);

  const handleSearch = () => {
  if (!selectedProperty) {
    toast.error('Please select a property first');
    return;
  }
  if (!selectedFollowBy) {
    toast.error('Please select a follow by option');
    return;
  }
  
  fetchFollowUpData(searchText); 
  setSearchText('')
};

  const columns = [
    { id: 'FlwEmpNm', label: 'Follow By', width: 80 },
    { id: 'EnqNo', label: 'EnquiryNo.', width: 80 },
    { id: 'EnqDt', label: 'EnqDate', width: 100 },
    { id: 'LastFlwUserName', label: 'LastFollowBy', width: 90 },
    { id: 'PropName', label: 'Property', width: 150 },
    { id: 'Status', label: 'Status', width: 50 },
    { id: 'EnqTypeNm', label: 'EnqType', width: 60 },
    { id: 'VisitSt', label: 'Visit', width: 50 },
    { id: 'Remark', label: 'Remark', width: 150 },
    { id: 'LastFlwDt', label: 'LastFollowUp', width: 100 },
    { id: 'NextFlwDt', label: 'NextFollowUp', width: 100 },
    { id: 'EnqBy', label: 'EnqBy', width: 120 },
    { id: 'EnqFor', label: 'EnqFor', width: 120 },
    { id: 'MobileNo', label: 'Mobile No.', width: 120 },
    { id: 'Tenure', label: 'Tenure', width: 60 },
    { id: 'Days', label: 'Days', width: 90 },
    { id: 'SourceBy', label: 'SourceBy', width: 120 },
    { id: 'SourceName', label: 'SourceName', width: 150 },
    { id: 'VisitEmpNm', label: 'Visit With', width: 120 },
    { id: 'VisitRemark', label: 'VisitRemark', width: 200 },
    { id: 'OtherRmk', label: 'Remark', width: 200 }
  ];

  useEffect(() => {
    if (properties.length === 0) {
      dispatch(fetchProperties());
    }
  }, [dispatch, properties.length]);
  useEffect(() => {
    if (selectedProperty) {
      const propIdToUse = selectedProperty?.Id || selectedProperty;
      fetchFollowBy(propIdToUse);
      setPropId(propIdToUse);
    }
    else {
      setFollowByOptions([]);
      setSelectedFollowBy(null);
    }
  }, [selectedProperty]);
  const fetchFollowBy = async (propId) => {
    try {
      const response = await axiosInstance.post(
        `TrnFlwup/TrnFlwupFlwUser`,
        {
          "PropId": propId || "",
          "Flag": ""
        }
      );
      setFollowByOptions([]);
      setSelectedFollowBy(null);
      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        const options = response.data.Data.map(user => ({
          ...user,
          Name: user.UserName,
          FlwUserId: user.FlwUserId
        }));
        setFollowByOptions(options);
        // if (options.length > 0) {
        //   setSelectedFollowBy(options[0]);
        // }
      }
    } catch (error) {
      console.error('Error fetching follow by options:', error);
    }
  };


  const handleFollowByChange = (event, newValue) => {
    setSelectedFollowBy(newValue);
  };

  const filteredRows = React.useMemo(() => {
    if (!dataFetched) return [];

    let filtered = allRows;
    if (globalSearchTerm) {
      filtered = filtered.filter(row =>
        Object.values(row).some(value =>
          value && value.toString().toLowerCase().includes(globalSearchTerm.toLowerCase())
        )
      );
    }

    filtered = filtered.filter(row => {
      return Object.entries(searchTerms).every(([columnId, term]) => {
        if (!term || columnId === 'PropId') return true;
        const value = row[columnId];
        if (typeof value === 'string') {
          return value.toLowerCase().includes(term.toLowerCase());
        } else if (typeof value === 'number') {
          return value.toString().includes(term);
        }
        return true;
      });
    });

    return filtered;
  }, [searchTerms, allRows, globalSearchTerm, dataFetched]);

  const sortedRows = React.useMemo(() => {
    if (!order || !orderBy) return filteredRows;

    return [...filteredRows].sort((a, b) => {
      const aValue = a[orderBy];
      const bValue = b[orderBy];

      if (aValue == null && bValue == null) return 0;
      if (aValue == null) return order === 'asc' ? 1 : -1;
      if (bValue == null) return order === 'asc' ? -1 : 1;

      if (orderBy.includes('Dt')) {
        const dateA = moment(aValue, 'DD-MM-YYYY');
        const dateB = moment(bValue, 'DD-MM-YYYY');
        return order === 'asc' ? dateA - dateB : dateB - dateA;
      }

      if (typeof aValue === 'string' && typeof bValue === 'string') {
        return order === 'asc'
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      }

      if (aValue < bValue) return order === 'asc' ? -1 : 1;
      if (aValue > bValue) return order === 'asc' ? 1 : -1;
      return 0;
    });
  }, [filteredRows, order, orderBy]);

  const paginatedRows = React.useMemo(() => {
    const startIndex = page * rowsPerPage;
    const endIndex = startIndex + rowsPerPage;
    return sortedRows.slice(startIndex, endIndex);
  }, [sortedRows, page, rowsPerPage]);

  useEffect(() => {
    fetchPropertyOptions();
  }, []);

  const handlePropertyChange = (event) => {
    const selectedId = event.target.value;
    dispatch(setLocalProperty({
      componentId: 'followUp',
      propertyId: selectedId
    }));
    setSelectedFollowBy(null);
    const selectedProp = propertyOptions.find(prop => prop.Id === selectedId);
    if (selectedId) {
      setSearchTerms(prev => ({ ...prev, PropId: selectedId }));
      setPage(0);
      fetchFollowBy(selectedId);
      setPropId(selectedId);
    } else {
      const { PropId, ...rest } = searchTerms;
      setSearchTerms(rest);
      fetchFollowBy("");
    }
  };

  const fetchFollowUpData = async (searchText = '') => {
    if (!selectedProperty) return;

    setLoading(true);
    try {
       let flagValue = statusFilter; 

    if (filterStatus === "Today") {
      flagValue = "Today";
    } else if (filterStatus === "Pen") {
      flagValue = "Pend";
    }
      const response = await axiosInstance.post(
        `TrnFlwup/GetTrnFlwupDashBoard?currentPage=1&limit=15`,
        {
          "PageNumber": 1,
          "PageSize": 15,
          "SearchText": searchText,
          "PropId": selectedProperty.Id || selectedProperty,
          Flag: flagValue,
          "FlwUserId": selectedFollowBy?.FlwUserId || ""
        }
      );

      if (response.data.Status === 0) {
        const formattedData = response?.data?.Data?.map(item => ({
          ...item,
          EnqDt: item.EnqDt ? moment(item.EnqDt).format('DD-MM-YYYY') : '',
          NextFlwDt: item.NextFlwDt ? moment(item.NextFlwDt).format('DD-MM-YYYY') : '',
          FlwDt: item.FlwDt ? moment(item.FlwDt).format('DD-MM-YYYY') : '',
          LastFlwDt: item.LastFlwDt ? moment(item.LastFlwDt).format('DD-MM-YYYY') : '',
          OtherRmk: item.OtherRmk,
          VisitSt: item.VisitSt === 'Y' ? 'Yes' : 'No',
          Status: item.flwStatus === "0" ? 'Cancel' :
            item.flwStatus === "1" ? 'Open' :
              item.flwStatus === "5" ? 'Close' :
                item.flwStatus || 'Unknown'
        }));

        setAllRows(formattedData);
        setPage(0);
        setDataFetched(true);
      } else {
        setAllRows([]);
        setDataFetched(true);
        console.error('Error fetching followup data:', response.data.Message);
      }
    } catch (error) {
      setAllRows([]);
      setDataFetched(true);
    } finally {
      setLoading(false);
    }
  };

  const handlePermittedClick = () => {
    if (AddRec === "1") {
      navigate('/enquiry');
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleSearchChange = (columnId, value) => {
    setSearchTerms(prev => ({ ...prev, [columnId]: value }));
    setPage(0);
  };

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  // const handleRowDoubleClick = (row) => {
  //   navigate('/FollowupForm', { state: { EnqId: row.EnqId, row, mode: 'view' } });
  // };
  const handleRowDoubleClick = (row) => {
    setSelectedRows(prev => {
      const newSet = new Set(prev);
      newSet.add(row.EnqId);
      return newSet;
    });
    sessionStorage.setItem('followupFormData', JSON.stringify({
      EnqId: row.EnqId,
      FlwId: row.FlwId,
      rowData: row,
      mode: 'view'
    }));
    window.open('/FollowupForm', '_blank');
  };

  const handleExportToExcel = async () => {
    if (!dataFetched || filteredRows.length === 0) return;

    setIsExporting(true);
    try {
      const exportData = sortedRows.map((row) => {
        let rowData = {};
        columns.forEach((col) => {
          let value = row[col.id];
          rowData[col.label] = value || "";
        });
        return rowData;
      });

      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "FollowUpData");
      XLSX.writeFile(workbook, `FollowUp_${new Date().toISOString().split('T')[0]}.xlsx`);
    } catch (error) {
      console.error("Export failed:", error);
    } finally {
      setIsExporting(false);
    }
  };

  const fetchPropertyOptions = async () => {
    try {
      const response = await axiosInstance.post(`PropertyMst/getPropertyMstdrp`, {
        UserId,
        Flag: ""
      });
      if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
        const proId = response.data.Data.map(user => ({
          ...user,
          id: user.Id
        }))
        setPropId(proId)
        setPropertyOptions(response.data.Data);
        if (selectedProperty) {
          fetchFollowBy(selectedProperty.Id || selectedProperty);
        } else if (response.data.Data.length > 0) {
          const firstProperty = response.data.Data[0];
          dispatch(setLocalProperty({
            componentId: 'followUp',
            propertyId: firstProperty.Id
          }));
          fetchFollowBy(firstProperty.Id);
        }
      }

    } catch (error) {
      console.error("Error fetching properties", error);
    }
  };

  const handleRetrieve = () => {
    if (!selectedProperty) {
      alert('Please select a property first');
      return;
    }
    if (!selectedFollowBy) {
      toast.error('Please select a follow by option');
      return;
    }
    setPage(0);
    setGlobalSearchTerm('');
    setSearchTerms({});
    setSelectedRows(new Set());
    fetchFollowUpData();
  };

  const getCellStyle = (columnId, value, row) => {
    if (columnId === 'EnqTypeNm') {
      switch (value) {
        case 'Hot': return { backgroundColor: '#FF0000', color: 'white', borderRadius: '4px' };
        case 'Warm': return { backgroundColor: '#FFBF00', color: 'white', borderRadius: '4px' };
        case 'Booked': return { backgroundColor: '#01bc5f', color: 'white', borderRadius: '4px' };
        case 'Refund': return { backgroundColor: '#4d7499', color: 'white', borderRadius: '4px' };
        case 'Not interested': return { backgroundColor: '#FF6347', color: 'white', borderRadius: '4px' };
        case 'Incorrect Lead': return { backgroundColor: '#922b21', color: 'white', borderRadius: '4px' };
        case 'Cold': return { backgroundColor: '#0000FF', color: 'white', borderRadius: '4px' };
        case 'Low Budget': return { backgroundColor: '#148f77', color: 'white', borderRadius: '4px' };
        case 'Others': return { backgroundColor: '#FFA500', color: 'white', borderRadius: '4px' };
        default: return {};
      }
    }
    if (columnId === 'VisitSt') {
      return value === 'Yes'
        ? { backgroundColor: '#4CAF50', color: 'white', borderRadius: '4px', textAlign: 'center' }
        : { backgroundColor: '#F44336', color: 'white', borderRadius: '4px', textAlign: 'center' };
    }
    if (columnId === 'Status') {
      switch (value) {
        case 'Cancel': return { backgroundColor: '#F44336', color: 'white', borderRadius: '4px', textAlign: 'center' };
        case 'Close': return { backgroundColor: '#4CAF50', color: 'white', borderRadius: '4px', textAlign: 'center' };
        case 'Open': return { backgroundColor: '#2196F3', color: 'white', borderRadius: '4px', textAlign: 'center' };
        default: return { textAlign: 'center' };
      }
    }
    return {};
  };

  const [resizeStartX, setResizeStartX] = useState(0);
  const [resizeStartWidth, setResizeStartWidth] = useState(0);

  const startResizing = (columnId, e) => {
    setColumnResizing(columnId);
    setResizeStartX(e.clientX);
    setResizeStartWidth(columnWidths[columnId]);
  };

  const handleMouseMove = (e) => {
    if (columnResizing) {
      const deltaX = e.clientX - resizeStartX;
      const newWidth = Math.max(50, resizeStartWidth + deltaX);

      setColumnWidths(prev => ({
        ...prev,
        [columnResizing]: newWidth
      }));
    }
  };

  const stopResizing = () => {
    setColumnResizing(null);
    setResizeStartX(0);
    setResizeStartWidth(0);
  };
  useEffect(() => {
    if (selectedProperty) {
      fetchFollowBy(selectedProperty.Id || selectedProperty);
    }
  }, []);
  const handleStatusChange = (event) => {
    setStatusFilter(event.target.value);
    setPage(0);
  };
  const handleTodayFollowUpClick = () => {
  if (!selectedProperty) {
    toast.error('Please select a property first');
    return;
  }
  setOpenTodayPopup(true);
};
const handleTodayEnqClick=()=>{
  setOpenTodayEPopup(true)
}

const BulkupdateEnquirys = () => {
   setOpenBulkUpdate(true)
  }

  const FollowByFilter = (
    <Autocomplete
      id="follow-by-filter"
      options={followByOptions}
      getOptionLabel={(option) => option.UserName || ""}
      value={selectedFollowBy}
      onChange={handleFollowByChange}
      size="small"
      sx={{ minWidth: 220 }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Follow By"
          variant="outlined"
          required
        />
      )}
      isOptionEqualToValue={(option, value) => option.UserId === value?.UserId}
    />
  );

  const PropertyFilterJSX = (
    <FormControl fullWidth size="small" sx={{ minWidth: 220 }}>
      <InputLabel id="property-select-label">Filter by Property</InputLabel>
      <Select
        labelId="property-select-label"
        id="property-select"
        value={selectedProperty?.Id || selectedProperty || ''}
        onChange={handlePropertyChange}
        label="Filter by Property"
      >
        {propertyOptions.map((property) => (
          <MenuItem key={property.Id} value={property.Id}>
            {property.Name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );

  const StatusFilterJSX = (
    <FormControl fullWidth size="small" sx={{ marginLeft: '6px' }}>
      <RadioGroup
        row
        aria-labelledby="status-radio-buttons-group-label"
        name="status-radio-buttons-group"
        value={statusFilter}
        onChange={handleStatusChange}
      >
        <Typography sx={{ mr: 1, mt: 1, fontWeight: 'bold' }}>Status:</Typography>
        <FormControlLabel value="Open" control={<Radio />} label="Open" />
        <FormControlLabel value="Close" control={<Radio />} label="Close" />
        <FormControlLabel value="Cancel" control={<Radio />} label="Cancel" />
      </RadioGroup>
    </FormControl>
  );

  const totalPages = Math.ceil(filteredRows.length / rowsPerPage);

  return (
    <>
      <Box sx={{ maxWidth: '93vw', margin: ' auto', padding: '10px', background: 'rgb(249, 249, 249)' }}>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
        <Box
          sx={{
            backgroundColor: "#ffffff",
            padding: { xs: "8px 16px", sm: "12px 16px" },
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            boxShadow: "0 2px 10px rgba(0, 0, 0, 0.05)",
            borderRadius: "12px",
            margin: "10px auto",
            maxWidth: "95%",
            flexDirection: { xs: "column", sm: "column", md: "row" }
          }}
        >
          <Breadcrumbs
            aria-label="breadcrumb"
            separator="›"
            sx={{
              fontSize: { xs: "14px", sm: "16px" },
              display: "flex",
              flexDirection: { xs: "column", sm: "column", md: "row" }
            }}
          >
            <Link
              color="#635bff"
              onClick={() => navigate('/dashboard')}
              underline="hover"
              sx={{ cursor: "pointer", fontWeight: "500" }}
            >
              Home
            </Link>
            <Link
              color="#635bff"
              onClick={() => navigate('/enquiry/pre-registration')}
              underline="hover"
              sx={{ cursor: "pointer", fontWeight: "500" }}
            >
              Booking(Pre-Registration)
            </Link>
            <Typography color="text.primary" sx={{ fontWeight: "500" }}>
              Follow Up
            </Typography>
          </Breadcrumbs>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
              gap: "16px",
              minWidth: "300px",
              flexDirection: { xs: "column", sm: "column", md: "row" },
              marginTop: { xs: "16px", sm: "16px", md: "0px" }
            }}
          >
            {PropertyFilterJSX}
            {FollowByFilter}

            <Button
              variant="contained"
              onClick={handleRetrieve}
              disabled={loading || !selectedProperty}
              sx={{
                backgroundColor: "#635bff",
                color: "#ffffff",
                borderRadius: '20px',
                minWidth: "100px",
                '&:hover': {
                  backgroundColor: '#524ccc'
                }
              }}
            >
              <ReplayIcon sx={{ fontSize: '18px', mr: 1 }} /> Retrieve
            </Button>
            <Tooltip title={AddRec !== "1" ? "You have no permission to add record" : ""}>
              <span>
                <Button
                  variant="contained"
                  onClick={handlePermittedClick}
                  size="small"
                  disabled={AddRec !== "1"}
                  sx={{
                    backgroundColor: "#635bff",
                    color: "#ffffff",
                    padding: "6px 14px",
                    borderRadius: '20px',
                    whiteSpace: 'nowrap',
                    '&:hover': {
                      backgroundColor: '#524ccc'
                    }
                  }}
                >
                  <AddIcon sx={{ fontSize: '18px', mr: 1 }} />
                  NEW ENQ
                </Button>
              </span>
            </Tooltip>

            {/* <Button
              variant="contained"
              onClick={handleExportToExcel}
              sx={{
                backgroundColor: "#635bff",
                color: "#ffffff",
                minWidth: "100px",
                borderRadius: '20px',
                '&:hover': {
                  backgroundColor: '#524ccc'
                }
              }}
              disabled={isExporting || !dataFetched || filteredRows.length === 0}
            >
              <SaveAltIcon sx={{ fontSize: '18px', mr: 1 }} />
              {isExporting ? "Exporting..." : "EXPORT"}
            </Button> */}

          </Box>

        </Box>
        <Box
          sx={{
            maxWidth: "93%",
            margin: '0 auto',
            display: 'flex',
            alignItems: 'center',
            gap: 2,
            flexWrap: 'wrap',
            paddingBottom: '8px',
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#635bff',
              borderRadius: '3px',
            }
          }}
        >

          <Box sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            gap: 2,
            width: { xs: '100%', sm: 'auto' },
            alignItems: { xs: 'flex-start', sm: 'center' }
          }}>
            <Box sx={{ flexShrink: 0 }}>
              {StatusFilterJSX}
            </Box>
            <FormControl size="small" sx={{
              minWidth: { xs: '100%', sm: 220 },
              flexShrink: 0
            }}>
              <InputLabel id="property-filter-label">Filter by Status</InputLabel>
              <Select
                labelId="property-filter-label"
                label="Filter by Status"
                value={filterStatus}
                onChange={(e) => {
                  setFilterStatus(e.target.value);
                  setPage(0);
                }}
                sx={{
                  backgroundColor: 'background.paper',
                  height: '40px',
                }}
              >
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Pen">Pending FollowUps</MenuItem>
                <MenuItem value="Today">Today FollowUps</MenuItem>
              </Select>
            </FormControl>
          </Box>

          <Box sx={{
            display: 'flex',
            alignItems: 'center',
            flexShrink: 0,
            width: { xs: '100%', sm: 'auto' }
          }}>
            <TextField
              size="small"
              variant="outlined"
              placeholder="Search here..."
              label="Search"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              sx={{
                minWidth: { xs: '100%', sm: 220 },
                '& .MuiOutlinedInput-root': {
                  backgroundColor: 'background.paper',
                  height: '40px',
                  borderTopRightRadius: 0,
                  borderBottomRightRadius: 0,
                },
              }}
              InputProps={{
                style: {
                  height: '40px',
                }
              }}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  handleSearch();
                }
              }}
            />
            <Button
              variant="contained"
              sx={{
                height: '40px',
                backgroundColor: '#635bff',
                '&:hover': {
                  backgroundColor: '#524ccc'
                },
                whiteSpace: 'nowrap',
                px: 2,
                borderTopLeftRadius: 0,
                borderBottomLeftRadius: 0,
                boxShadow: 'none',
                marginLeft: '-1px',
              }}
              onClick={handleSearch}
              disabled={!searchText}
            >
              Search
            </Button>
          </Box>
          <Button
            size='small'
            variant='contained'
            sx={{
              whiteSpace: 'nowrap',
              borderRadius: '20px',
              backgroundColor: '#635bff',
              flexShrink: 0,
              '&:hover': {
                backgroundColor: '#524ccc'
              },
              width: { xs: '100%', sm: 'auto' }
            }}
            disabled={allRows.length === 0}
            onClick={handleTodayFollowUpClick}
          >
            Today FollowUps 
          </Button>
          <Button
            size='small'
            variant='contained'
            sx={{
              whiteSpace: 'nowrap',
              borderRadius: '20px',
              backgroundColor: '#635bff',
              flexShrink: 0,
              '&:hover': {
                backgroundColor: '#524ccc'
              },
              width: { xs: '100%', sm: 'auto' }
            }}
            disabled={allRows.length === 0}
            onClick={handleTodayEnqClick}
          >
            Today Enquiries
          </Button>
          <Button
            size='small'
            variant='contained'
            sx={{
              whiteSpace: 'nowrap',
              borderRadius: '20px',
              backgroundColor: '#635bff',
              flexShrink: 0,
              '&:hover': {
                backgroundColor: '#524ccc'
              },
              width: { xs: '100%', sm: 'auto' }
            }}
            disabled={allRows.length === 0}
            onClick={BulkupdateEnquirys}
          >
            Bulk Update
          </Button>
        </Box>
        <Paper sx={{ width: '94%', overflow: 'hidden', boxShadow: 3, margin: 'auto' }}>
          <Box sx={{ position: 'relative' }}>
            <TableContainer
              sx={{
                maxHeight: 'calc(100vh - 250px)',
                '&::-webkit-scrollbar': {
                  height: '5px',
                  width: '5px'
                },
                '&::-webkit-scrollbar-thumb': {
                  backgroundColor: 'gray',
                  borderRadius: '4px'
                }
              }}
              onMouseMove={handleMouseMove}
              onMouseUp={stopResizing}
              onMouseLeave={stopResizing}
            >
              <Table stickyHeader aria-label="sticky table" size="small" sx={{ padding: '10px' }}>
                <TableHead>
                  <TableRow>
                    {columns.map((column) => (
                      <TableCell
                        key={column.id}
                        sx={{
                          width: columnWidths[column.id] || column.width,
                          minWidth: columnWidths[column.id] || column.width,
                          backgroundColor: '#dddbff',
                          fontWeight: 'bold',
                          padding: '4px 3px',
                          borderRight: '1px solid #e0e0e0',
                          position: 'sticky',
                          '&:last-child': {
                            borderRight: 'none'
                          }
                        }}
                        sortDirection={orderBy === column.id ? order : false}
                      >
                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                          <TableSortLabel
                            active={orderBy === column.id}
                            direction={orderBy === column.id ? order : 'asc'}
                            onClick={() => handleRequestSort(column.id)}
                            sx={{ flexGrow: 1 }}
                            IconComponent={() => (
                              <Box component="span" sx={{
                                opacity: orderBy === column.id ? 1 : 0.3,
                                transition: 'opacity 0.2s',
                                '&:hover': { opacity: 1 }
                              }}>
                                {orderBy === column.id ?
                                  (order === 'asc' ? <NorthIcon sx={{ fontSize: 15, marginTop: 1 }} /> :
                                    <SouthIcon sx={{ fontSize: 15, marginTop: 1 }} />) :
                                  <SouthIcon sx={{ fontSize: 15, marginTop: 1, opacity: 0.3 }} />
                                }
                              </Box>
                            )}
                          >
                            {column.label}
                            {orderBy === column.id ? (
                              <Box component="span" sx={visuallyHidden}>
                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                              </Box>
                            ) : null}
                          </TableSortLabel>
                        </Box>
                        <Box>
                          <TextField
                            size="small"
                            variant="outlined"
                            placeholder={`Search`}
                            value={searchTerms[column.id] || ''}
                            onChange={(e) => handleSearchChange(column.id, e.target.value)}
                            sx={{
                              width: '100%',
                              '& .MuiOutlinedInput-root': {
                                borderRadius: '8px',
                                backgroundColor: '#f9f9f9',
                                fontSize: '0.75rem',
                                height: '24px',
                                padding: '0 8px'
                              },
                              '& .MuiOutlinedInput-input': {
                                padding: '6px 4px'
                              }
                            }}
                          />
                        </Box>
                        <Box
                          sx={{
                            position: 'absolute',
                            right: 0,
                            top: 0,
                            height: '100%',
                            width: '4px',
                            cursor: 'col-resize',
                            backgroundColor: columnResizing === column.id ? '#635bff' : 'transparent',
                            '&:hover': {
                              backgroundColor: '#635bff'
                            }
                          }}
                          onMouseDown={(e) => startResizing(column.id, e)}
                        />
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                {loading && (
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={columns.length} sx={{ textAlign: 'center', py: 4 }}>
                        <CircularProgress />
                        <Typography variant="body2" sx={{ mt: 2 }}>
                          Loading data...
                        </Typography>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
                <TableBody>
                  {!loading && !dataFetched ? (
                    <TableRow>
                      <TableCell colSpan={columns.length} sx={{ textAlign: 'center', py: 4 }}>
                        <Typography variant="body2" color="textSecondary">
                          Click "Retrieve" button to load data
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ) : !loading && paginatedRows.length > 0 ? (
                    paginatedRows.map((row, index) => (
                      <TableRow
                        hover
                        key={row.EnqId || index}
                        onDoubleClick={() => handleRowDoubleClick(row)}
                        sx={{
                          '&:hover': { cursor: 'pointer' },
                          ...(moment(row.FlwDt, 'DD-MM-YYYY').isSame(moment().startOf('day'), 'day') || selectedRows.has(row.EnqId)
                            ? {
                              backgroundColor: '#ccffcc !important',
                              '&:hover': {
                                backgroundColor: '#b3ffb3 !important'
                              }
                            }
                            : {
                              '&:nth-of-type(even)': {
                                backgroundColor: '#f9f9f9'
                              }
                            }
                          )
                        }}
                      >
                        {columns.map((column) => {
                          const value = row[column.id];
                          return (
                            <TableCell
                              key={column.id}
                              sx={{
                                width: columnWidths[column.id] || column.width,
                                minWidth: columnWidths[column.id] || column.width,
                                maxWidth: columnWidths[column.id] || column.width,
                                padding: '1px 6px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                                borderRight: '1px solid #e0e0e0',
                                '&:last-child': {
                                  borderRight: 'none'
                                },
                                ...getCellStyle(column.id, value),
                              }}
                              className="no-user-select"
                            >
                              <Tooltip
                                title={value}
                                arrow
                                placement="top"
                                componentsProps={{
                                  tooltip: {
                                    sx: {
                                      fontSize: '14px',
                                      maxWidth: '500px',
                                    }
                                  }
                                }}
                              >
                                <span>{value}</span>
                              </Tooltip>
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    ))
                  ) : !loading && dataFetched ? (
                    <TableRow>
                      <TableCell colSpan={columns.length} sx={{ textAlign: 'center', py: 4 }}>
                        <Typography variant="body2" color="textSecondary">
                          No records found
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ) : null}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          {dataFetched && (
            <TablePagination
              rowsPerPageOptions={[15, 30, 50, 100, 250, 500,]}
              component="div"
              count={filteredRows.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={(event) => {
                const newRowsPerPage = parseInt(event.target.value, 10);
                setRowsPerPage(newRowsPerPage);
                setPage(0);
              }}
              sx={{
                backgroundColor: "#dddbff",
                borderTop: "1px solid #ddd",
                color: "#333",
                borderRadius: "0 0 12px 12px",
                "& .MuiToolbar-root": {
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                  width: "100%",
                  flexWrap: "wrap",
                },
                "& .MuiTablePagination-selectLabel": {
                  marginBottom: 2,
                },
                "& .MuiTablePagination-select": {
                  marginBottom: 0,
                },
              }}
              ActionsComponent={({ onPageChange }) => (
                <Stack
                  direction="row"
                  alignItems="center"
                  sx={{
                    justifyContent: "center",
                    marginLeft: "16px",
                  }}
                >
                  <Pagination
                    count={totalPages}
                    page={page + 1}
                    onChange={(event, newPage) => onPageChange(null, newPage - 1)}
                    showFirstButton
                    showLastButton
                    sx={{
                      "& .MuiPaginationItem-root.Mui-selected": {
                        backgroundColor: "#635bff",
                        color: "#ffffff",
                      },
                    }}
                  />
                </Stack>
              )}
              labelDisplayedRows={({ from, to, count }) =>
                `${from}-${to} of ${count !== -1 ? count : `more than ${to}`}`
              }
              labelRowsPerPage="Rows per page:"
            />
          )}
        </Paper>
        <TodayFollowUpPopup
          open={openTodayPopup}
          onClose={() => setOpenTodayPopup(false)}
          propId={selectedProperty?.Id || selectedProperty}
          selectedFollowBy={selectedFollowBy}
        />
        <TodayEnqListPopup
          open={openTodayEPopup}
          onClose={() => setOpenTodayEPopup(false)}
          propId={selectedProperty?.Id || selectedProperty}
          selectedFollowBy={selectedFollowBy}
        />
        <BulkUpdateEnquiryDialog
          open={openBulkUpdate}
          onClose={() => setOpenBulkUpdate(false)}
          propId={selectedProperty}
          // fetchEnquiry={fetchEnquiry}
          selectedFollowBy={selectedFollowBy}
          statusFilter={statusFilter}
        />
      </Box>
    </>
  );
};



export default TableFollowUp;